import { textNodeToTextPrinter } from './common.text.js';

const htmlNodeToTextPrinter = (node, context) => {
  if (!node.children) {
    return "";
  }
  return context.printChildren(node.children, {
    html: htmlNodeToTextPrinter,
    text: textNodeToTextPrinter
  }).join("");
};

export { htmlNodeToTextPrinter };
//# sourceMappingURL=common.html.js.map
